import { useMemo, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import Sidebar from './components/Sidebar';
import TaskInput from './components/TaskInput';
import TaskList from './components/TaskList';
import './App.css';

const { FiCalendar, FiSun } = FiIcons;

const initialTasks = [
  { id: 1, title: 'Design the new onboarding flow', category: 'Work', priority: 'high', done: false },
  { id: 2, title: 'Pick up groceries for dinner', category: 'Personal', priority: 'low', done: false },
  { id: 3, title: 'Reply to Maya about Saturday', category: 'Personal', priority: 'medium', done: true },
  { id: 4, title: 'Prepare slides for Thursday review', category: 'Work', priority: 'high', done: false }
];

function App() {
  const [tasks, setTasks] = useState(initialTasks);
  const [filter, setFilter] = useState('all');
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [collapsed, setCollapsed] = useState(false);

  const categories = useMemo(
    () => Array.from(new Set(tasks.map((task) => task.category))).sort(),
    [tasks]
  );

  const visibleTasks = useMemo(() => tasks.filter((task) => {
    if (filter === 'active' && task.done) return false;
    if (filter === 'done' && !task.done) return false;
    if (categoryFilter !== 'all' && task.category !== categoryFilter) return false;
    return true;
  }), [tasks, filter, categoryFilter]);

  const completed = tasks.filter((task) => task.done).length;
  const progress = tasks.length ? Math.round((completed / tasks.length) * 100) : 0;
  const counts = { all: tasks.length, active: tasks.length - completed, done: completed };

  const addTask = (title, priority) => {
    setTasks((current) => [...current, { id: Date.now(), title, category: 'Today', priority, done: false }]);
  };

  const toggleTask = (id) => {
    setTasks((current) => current.map((task) => task.id === id ? { ...task, done: !task.done } : task));
  };

  const deleteTask = (id) => setTasks((current) => current.filter((task) => task.id !== id));
  const clearDone = () => setTasks((current) => current.filter((task) => !task.done));

  return (
    <main className="app-shell">
      <div className={`dashboard ${collapsed ? 'sidebar-collapsed' : ''}`}>
        <Sidebar
          filter={filter}
          setFilter={setFilter}
          counts={counts}
          progress={progress}
          onClearDone={clearDone}
          categories={categories}
          categoryFilter={categoryFilter}
          setCategoryFilter={setCategoryFilter}
          collapsed={collapsed}
          onToggleCollapse={() => setCollapsed((value) => !value)}
        />

        <section className="panel">
          <header className="panel-header">
            <div>
              <p className="eyebrow"><SafeIcon icon={FiSun} /> TODAY</p>
              <h1>Make room for<br /><em>what matters.</em></h1>
            </div>
            <div className="date-pill"><SafeIcon icon={FiCalendar} /> Tuesday, May 14</div>
          </header>

          <TaskInput onAdd={addTask} />
          <TaskList tasks={visibleTasks} onToggle={toggleTask} onDelete={deleteTask} />

          <footer>Small steps add up. You are doing great.</footer>
        </section>
      </div>
    </main>
  );
}

export default App;